module.exports = __webpack_public_path__ + "img/pre-banner-top.589eaf4e.svg";